(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Submitting on change removes the Update step. The <noscript> button stays
  // for anyone without this.
  (function () {
    const form = document.querySelector('.cart__form');
    if (!form) return;

    let timer;
    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-quantity-input]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => form.requestSubmit(), 350);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  // Counts the figures up once, as they scroll into view. The final value is
  // already in the markup, so with no script or reduced motion it is simply
  // the number — nothing is hidden behind this.
  (function () {
    const targets = document.querySelectorAll('[data-count-to]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const run = (el) => {
      const raw = el.dataset.countTo || '';
      const target = parseFloat(raw.replace(/[^\d.]/g, ''));
      if (!isFinite(target)) return;

      // Keep any non-numeric parts, e.g. a leading currency mark.
      const prefix = raw.slice(0, raw.search(/[\d.]/));
      const suffix = raw.slice(raw.search(/[\d.]/) + String(target).length);
      const decimals = (String(target).split('.')[1] || '').length;

      const duration = 1100;
      const start = performance.now();

      const tick = (now) => {
        const t = Math.min(1, (now - start) / duration);
        // easeOutCubic: fast first, settles on the number
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = raw;
      };

      requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          run(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    targets.forEach((el) => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-buy-bar]');
    if (!bar) return;

    // Keep the bar on whatever variant the hero is showing.
    const mirror = bar.querySelector('[data-buy-bar-variant]');
    if (mirror) {
      document.addEventListener('change', (event) => {
        const field = event.target;
        if (field.name === 'id' && field.checked && !bar.contains(field)) {
          mirror.value = field.value;
        }
      });
    }

    const desktopHidden =
      bar.classList.contains('buybar--mobile') && !bar.hasAttribute('data-editor');
    const allowed = () => !desktopHidden || window.matchMedia('(max-width: 899px)').matches;

    const show = () => {
      if (!allowed()) return;
      if (bar.hidden) {
        bar.hidden = false;
        // Next frame, so the transform transition actually runs.
        requestAnimationFrame(() => bar.classList.add('is-visible'));
      } else {
        bar.classList.add('is-visible');
      }
      document.body.classList.add('has-buybar');
    };

    const hide = () => {
      bar.classList.remove('is-visible');
      document.body.classList.remove('has-buybar');
    };

    // Watch the hero's buy controls, not the whole hero. The hero runs over
    // 1000px tall, so observing it means scrolling past the entire section
    // before the bar appears — by which point the visitor has already lost the
    // Add to cart button. The right trigger is that button leaving the screen.
    const hero =
      document.querySelector('.hero__actions') ||
      document.querySelector('.hero__form') ||
      document.querySelector('.hero');

    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => (entry.isIntersecting ? hide() : show()),
        { rootMargin: '-72px 0px 0px 0px', threshold: 0 }
      ).observe(hero);
      return;
    }

    const after = parseInt(bar.dataset.revealAfter, 10) || 600;
    const onScroll = () => (window.scrollY > after ? show() : hide());
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Arrows drive the same scroll container the user can already swipe. They
  // are revealed only when the row overflows, and disabled at each end.
  (function () {
    document.querySelectorAll('.quotes').forEach((section) => {
      const rail = section.querySelector('.quotes__rail');
      const nav = section.querySelector('[data-rail-nav]');
      if (!rail || !nav) return;

      const prev = nav.querySelector('[data-rail-prev]');
      const next = nav.querySelector('[data-rail-next]');

      // One card plus the gap, so a press advances exactly one review.
      const step = () => {
        const card = rail.querySelector('.quotes__card');
        if (!card) return rail.clientWidth;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const overflows = () => rail.scrollWidth > rail.clientWidth + 4;

      const sync = () => {
        if (!overflows()) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;
        // 2px of slack: sub-pixel widths never quite reach the exact end.
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };

      const go = (dir) => rail.scrollBy({ left: dir * step(), behavior: 'smooth' });

      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
